import { ICustomMedia } from './interface/media.interface'
import { CMSCommentWsDTOCMSCommentWsDTO } from './shared.model'

export class CreditClaimList {
  creditClaims?: CreditClaim[]
}

export class CreditClaim {
  amount?: number
  claimDate?: string
  comments?: CMSCommentWsDTOCMSCommentWsDTO[]
  createdBy?: string
  creditClaimCode?: string
  description?: string
  distributorNo?: string
  endCustomerNo?: string
  images?: ICustomMedia[]
  invoiceNumber?: string
  items?: CreditClaimItem[]
  pod?: string
  reason?: string
  resolutionDocumentUrl?: string
  status?: string
  purchaseOrderNumber?: string
  ticketId?: number
  stockQuestion?: string
  invoiceQuestion?: string
  addressQuestion?: string
}

export class CreditClaimItem {
  claimQuantity?: number
  productCode?: string
  deliveredQuantity?: number
  itemPrice?: number
  overSuppliedItem?: boolean
  uom?: string
}
export class ClaimReason {
  reason?: string
  order?: number
}

export class CreditClaimMediaUpload {
  code?: string
  downloadUrl?: string
  filename?: string
  url?: string
}

export class CreditClaimPhotoAndComment {
  creditClaimMediaUploads?: CreditClaimMediaUpload[]
  comment?: string
}
